import { AlertCircle, CheckCircle2, Info, Loader2, TriangleAlert } from "lucide-react"
import { Toaster as Sonner, toast } from "sonner"

import { cn } from "@/lib/utils"

const Toaster = ({
  className,
  theme = "dark",
  icons,
  toastOptions,
  ...props
}) => {
  const classNames = toastOptions?.classNames || {}

  return (
    <Sonner
      theme={theme}
      closeButton={false}
      gap={8}
      className={cn("toaster app-alert-toaster group", className)}
      icons={{
        success: <CheckCircle2 aria-hidden="true" />,
        error: <AlertCircle aria-hidden="true" />,
        warning: <TriangleAlert aria-hidden="true" />,
        info: <Info aria-hidden="true" />,
        loading: <Loader2 aria-hidden="true" className="app-alert-loader" />,
        ...icons,
      }}
      toastOptions={{
        ...toastOptions,
        classNames: {
          toast: cn("app-alert-toast", classNames.toast),
          title: cn("app-alert-title", classNames.title),
          description: cn("app-alert-description", classNames.description),
          content: cn("app-alert-content", classNames.content),
          icon: cn("app-alert-icon", classNames.icon),
          actionButton: cn("app-alert-action", classNames.actionButton),
          cancelButton: cn("app-alert-cancel", classNames.cancelButton),
          closeButton: cn("app-alert-close", classNames.closeButton),
          success: cn("app-alert-success", classNames.success),
          error: cn("app-alert-error", classNames.error),
          warning: cn("app-alert-warning", classNames.warning),
          info: cn("app-alert-info", classNames.info),
          loading: cn("app-alert-loading", classNames.loading),
          default: cn("app-alert-default", classNames.default),
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
